/**
 * @description 获取业务阴影颜色
 * @param {string} path 业务页面path
 * @returns string
 */
export const getShadowColor = path => {
  let shadowColor = ''
  switch (path) {
    case '/communityIntro': shadowColor = 'rgba(149, 157, 165, 0.2)'
      break
    case '/publicityParty': shadowColor = 'rgba(129, 0, 0, 0.1)'
      break
    case '/publicityHousing': shadowColor = 'rgba(7, 60, 0, 0.1)'
      break
    case '/fireFighting': shadowColor = 'rgba(7, 60, 0, 0.1)'
      break
    case '/veteransService': shadowColor = 'rgba(7, 60, 0, 0.06)'
      break
    case '/partyConduct': shadowColor = 'rgba(0, 65, 150, 0.1)'
      break
    case '/femaleFederation': shadowColor = 'rgba(129, 0, 0, 0.1)'
      break
    default: shadowColor = 'rgba(149, 157, 165, 0.2)'
  }
  return shadowColor
}

/**
 * @description 获取业务主题颜色
 * @param {*} path 业务页面path
 * @param {*} transparency rgba染色透明度, 默认1(0~1)
 * @returns string
 */
export const getPageThemeColor = (path, transparency = 1) => {
  let themeColor = ''
  switch (path) {
    case '/communityIntro': themeColor = `rgba(96, 166, 143, ${transparency})`
      break
    case '/publicityParty': themeColor = `rgba(221, 65, 54, ${transparency})`
      break
    case '/publicityHousing': themeColor = `rgba(96, 182, 66, ${transparency})`
      break
    case '/fireFighting': themeColor = `rgba(237, 106, 75, ${transparency})`
      break
    case '/veteransService': themeColor = `rgba(255, 92, 83, ${transparency})` // rgb(214, 102, 104)
      break
    case '/partyConduct': themeColor = `rgba(21, 149, 195, ${transparency})`
      break
    case '/femaleFederation': themeColor = `rgb(250, 63, 155, ${transparency})`
      break
    case '/newPage8': themeColor = `rgb(97, 163, 148, ${transparency})`
      break
    case '/newPage9': themeColor = `rgb(44, 153, 178, ${transparency})`
      break
    case '/newPage10': themeColor = `rgb(251, 212, 200, ${transparency})`
      break
    case '/newPage11': themeColor = `rgb(95, 151, 125, ${transparency})`
      break
    case '/newPage12': themeColor = `rgb(105, 181, 193, ${transparency})`
      break
    default: themeColor = `rgba(221, 65, 54, ${transparency})`
  }
  return themeColor
}

import { getFileType } from '@/utils/common.js'
/**
 * @description 获取文件类型对应logo图
 * @param {*} filename 文件名
 * @param {*} size
 * @returns string
 */
export const getFileTypeLogo = (filename, size = 'normal') => {
  const fileType = getFileType(filename)
  const fileLogoObj = {
    xlsx: require('imgs/modules/logo-excel.png'),
    xls: require('imgs/modules/logo-excel.png'),
    docx: require('imgs/modules/logo-word.png'),
    doc: require('imgs/modules/logo-word.png'),
    pdf: require('imgs/modules/logo-pdf.png'),
    mp3: require('imgs/modules/audio-logo.png')
  }
  const smallFileObj = {
    xlsx: require('imgs/modules/dialog-modules/logo-excel-small.png'),
    xls: require('imgs/modules/dialog-modules/logo-excel-small.png'),
    docx: require('imgs/modules/dialog-modules/logo-word-small.png'),
    doc: require('imgs/modules/dialog-modules/logo-word-small.png'),
    pdf: require('imgs/modules/dialog-modules/logo-pdf-small.png'),
    mp3: require('imgs/modules/audio-logo.png')
  }
  return size === 'normal' ? fileLogoObj[fileType] : smallFileObj[fileType]
}

/**
 * @description 获取当前业务页面渐变色
 * @param {*} path 业务页面path
 * @returns string
 */
export const getLinearColor = path => {
  let linearArr = []
  switch (path) {
    case '/publicityParty': linearArr = ['#F36359', '#DD4136']
      break
    case '/publicityHousing': linearArr = ['#76D157', '#60B642']
      break
    case '/fireFighting': linearArr = ['#F9886D', '#ED6A4B']
      break
    case '/veteransService': linearArr = ['#FE8079', '#FF5C53']
      break
    case '/partyConduct': linearArr = ['#1394C8', '#3B9F74']
      break
    case '/femaleFederation': linearArr = ['#FD6DB4', '#FA3F9B']
      break
    case '/newPage8': linearArr = ['#89C5BC', '#7AB2AA']
      break
    case '/newPage9': linearArr = ['#5AC1D6', '#4FABBE']
      break
    case '/newPage10': linearArr = ['#E9CA82', '#D9BF82']
      break
    case '/newPage11': linearArr = ['#57C098', '#77A996']
      break
    case '/newPage12': linearArr = ['#5FDA85', '#7FC1CC']
      break
    default: linearArr = ['#76D157', '#60B642']
  }
  return linearArr
}

// modules id-7: background image
/**
 * @description 获取组件id7背景图
 * @param {*} path 业务页面path
 * @returns string
 */
export const getModule7ImgBg = path => {
  let img = ''
  switch (path) {
    case '/publicityParty': img = require('imgs/modules/group-bg/id-2-retanc-bg.png')
      break
    case '/publicityHousing': img = require('imgs/modules/group-bg/id-3-retanc-bg.png')
      break
    case '/fireFighting': img = require('imgs/modules/group-bg/id-4-retanc-bg.png')
      break
    case '/veteransService': img = require('imgs/modules/group-bg/id-5-retanc-bg.png')
      break
    case '/partyConduct': img = require('imgs/modules/group-bg/id-6-retanc-bg.png')
      break
    case '/femaleFederation': img = require('imgs/modules/group-bg/id-7-retanc-bg.png')
      break
    case '/newPage8': img = require('imgs/modules/group-bg/id-8-retanc-bg.png')
      break
    case '/newPage9': img = require('imgs/modules/group-bg/id-9-retanc-bg.png')
      break
    case '/newPage10': img = require('imgs/modules/group-bg/id-10-retanc-bg.png')
      break
    case '/newPage11': img = require('imgs/modules/group-bg/id-11-retanc-bg.png')
      break
    case '/newPage12': img = require('imgs/modules/group-bg/id-12-retanc-bg.png')
      break
    default: img = require('imgs/modules/group-bg/id-2-retanc-bg.png')
  }
  return img
}

/**
 * @description 获取组件id21背景图
 * @param {*} path 业务页面path
 * @returns string
 */
export const getModule21ImgBg = path => {
  let img = ''
  switch (path) {
    case '/publicityParty': img = require('imgs/modules/group-bg/itembg-id-2.png')
      break
    case '/publicityHousing': img = require('imgs/modules/group-bg/itembg-id-3.png')
      break
    case '/fireFighting': img = require('imgs/modules/group-bg/itembg-id-4.png')
      break
    case '/veteransService': img = require('imgs/modules/group-bg/itembg-id-5.png')
      break
    case '/partyConduct': img = require('imgs/modules/group-bg/itembg-id-6.png')
      break
    case '/femaleFederation': img = require('imgs/modules/group-bg/itembg-id-7.png')
      break
    case '/newPage8': img = require('imgs/modules/group-bg/itembg-id-8.png')
      break
    case '/newPage9': img = require('imgs/modules/group-bg/itembg-id-9.png')
      break
    case '/newPage10': img = require('imgs/modules/group-bg/itembg-id-10.png')
      break
    case '/newPage11': img = require('imgs/modules/group-bg/itembg-id-11.png')
      break
    case '/newPage12': img = require('imgs/modules/group-bg/itembg-id-12.png')
      break
    default: img = require('imgs/modules/group-bg/itembg-id-3.png')
  }
  return img
}

/**
 * @description 获取组件id59logo图
 * @param {*} path 业务页面path
 * @returns string
 */
export const getModule59ImgLogo = path => {
  let img = ''
  switch (path) {
    case '/publicityParty': img = require('imgs/modules/group-bg/module59-page2.png')
      break
    case '/publicityHousing': img = require('imgs/modules/group-bg/module59-page3.png')
      break
    case '/fireFighting': img = require('imgs/modules/group-bg/module59-page4.png')
      break
    case '/veteransService': img = require('imgs/modules/group-bg/module59-page5.png')
      break
    case '/partyConduct': img = require('imgs/modules/group-bg/module59-page6.png')
      break
    case '/femaleFederation': img = require('imgs/modules/group-bg/module59-page7.png')
      break
    case '/newPage8': img = require('imgs/modules/group-bg/module59-page8.png')
      break
    case '/newPage9': img = require('imgs/modules/group-bg/module59-page9.png')
      break
    case '/newPage10': img = require('imgs/modules/group-bg/module59-page10.png')
      break
    case '/newPage11': img = require('imgs/modules/group-bg/module59-page11.png')
      break
    case '/newPage12': img = require('imgs/modules/group-bg/module59-page12.png')
      break
    default: img = require('imgs/modules/group-bg/module59-page3.png')
  }
  return img
}
